import { Button, Panel, PanelBody, PanelRow, TextareaControl, ToggleControl, __experimentalUnitControl as UnitControl } from "@wordpress/components";
import { withDispatch, withSelect } from "@wordpress/data";
import { __ } from "@wordpress/i18n";
import { compose } from "@wordpress/compose";

import BColor from "./../../../../utils/components/BColor/BColor";
import SimpleLoader from "./../../../../utils/components/Loader/SimpleLoader";
import panelBodyController from "./../../../../utils/panelBodyController";
import { useEffect } from "@wordpress/element";
import { useWPOptionMutation } from "../../../../utils/hooks";

const Options = ({ popup, setPopup }) => {
  const { pages, background, color, headingFontSize, descFontSize, buttonGap, btnColor, btnBG, closeBtnColor, closeBtnBG, enabled } = popup;
  const { saveData, isLoading } = useWPOptionMutation("vstr_popup_design", { type: "object" });

  useEffect(() => {
    panelBodyController();
  }, []);

  return (
    <div className="b-custom-panel">
      <div className="d-flex justify-end items-center m-2">
        {isLoading && <SimpleLoader />}
        <Button
          variant="primary"
          className="ml-2 pl-8 pr-8"
          onClick={() => {
            saveData(popup);
          }}
          disabled={isLoading}
        >
          {__("Update", "visitor-feedback")}
        </Button>
      </div>
      <Panel onSelect={() => panelBodyController()}>
        <PanelBody title={__("Options", "visitor-feedback")}>
          <PanelRow>
            <ToggleControl label={__("Enabled", "visitor-feedback")} checked={enabled} onChange={() => setPopup({ enabled: !enabled })} />
          </PanelRow>
          {enabled && (
            // <PanelRow>
            <TextareaControl help={__("Leave empty to show on every page. every page should be new line", "bpm")} label={__("Pages", "visitor-feedback")} rows={5} value={pages} onChange={(pages) => setPopup({ pages })} placeholder={`every page should be a new line`} />
            // </PanelRow>
          )}
        </PanelBody>
        <PanelBody title="Style">
          <PanelRow>
            <label>{__("Popup Background", "visitor-feedback")}</label>
            <BColor value={background} onChange={(background) => setPopup({ background })} />
          </PanelRow>
          <PanelRow>
            <label>{__("Text Color", "visitor-feedback")}</label>
            <BColor value={color} onChange={(color) => setPopup({ color })} />
          </PanelRow>
          <PanelRow>
            <UnitControl label={__("Heading Font Size", "")} labelPosition="side" value={headingFontSize} onChange={(headingFontSize) => setPopup({ headingFontSize })}></UnitControl>
          </PanelRow>
          <PanelRow>
            <UnitControl label={__("Description Font Size", "")} labelPosition="side" value={descFontSize} onChange={(descFontSize) => setPopup({ descFontSize })}></UnitControl>
          </PanelRow>
          <PanelRow>
            <label>{__("Button Gap", "visitor-feedback")}</label>
            <UnitControl onChange={(buttonGap) => setPopup({ buttonGap })} value={buttonGap} />
          </PanelRow>
          <PanelRow>
            <label>{__("Button Text Color", "visitor-feedback")}</label>
            <BColor value={btnColor} onChange={(btnColor) => setPopup({ btnColor })} />
          </PanelRow>
          <PanelRow>
            <label>{__("Button Background", "visitor-feedback")}</label>
            <BColor value={btnBG} onChange={(btnBG) => setPopup({ btnBG })} />
          </PanelRow>
        </PanelBody>
        <PanelBody title={__("Close Button", "visitor-feedback")} initialOpen={false}>
          <PanelRow>
            <label>{__("Color", "visitor-feedback")}</label>
            <BColor value={closeBtnColor} onChange={(closeBtnColor) => setPopup({ closeBtnColor })} />
          </PanelRow>
          <PanelRow>
            <label>{__("Background", "visitor-feedback")}</label>
            <BColor value={closeBtnBG} onChange={(closeBtnBG) => setPopup({ closeBtnBG })} />
          </PanelRow>
        </PanelBody>
      </Panel>
    </div>
  );
};

export default compose([
  withSelect((select) => {
    const { getPopup } = select("visitor-feedback");
    return {
      popup: getPopup(),
    };
  }),
  withDispatch((dispatch) => {
    const { setPopup } = dispatch("visitor-feedback");
    return {
      setPopup,
    };
  }),
])(Options);
